// fileLanguageSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fileId: null,
  targetLanguageId: null,
  targetLanguageName: null, // Optional: for debugging or display
};

const fileLanguageSlice = createSlice({
  name: "fileLanguage",
  initialState,
  reducers: {
    setFileAndLanguage: (state, action) => {
      state.fileId = action.payload.fileId;
      state.targetLanguageId = action.payload.targetLanguageId;
      state.targetLanguageName = action.payload.targetLanguageName || null;
    },
    clearFileAndLanguage: (state) => {
      state.fileId = null;
      state.targetLanguageId = null;
      state.targetLanguageName = null;
    },
  },
});

export const { setFileAndLanguage, clearFileAndLanguage } = fileLanguageSlice.actions;

export default fileLanguageSlice.reducer;
